import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [activeSection, setActiveSection] = useState('home');

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0A1628]/85 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/f4063e67-ecef-4d94-835c-f79e12c49a72.png" 
              alt="TAFARUCI SH.P.K. Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className="text-lg font-bold text-white tracking-wider">
              TAFARUCI SH.P.K.
            </h1>
          </div>

          <div className="flex items-center gap-10">
            {[
              { id: 'home', label: 'Home' },
              { id: 'about', label: 'About' },
              { id: 'products', label: 'Products' },
              { id: 'features', label: 'Features' },
              { id: 'contact', label: 'Contact' },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-medium text-white transition-all duration-300 hover:text-[#00D9FF] cursor-pointer whitespace-nowrap relative ${
                  activeSection === item.id ? 'after:absolute after:bottom-[-4px] after:left-0 after:right-0 after:h-[2px] after:bg-[#00D9FF]' : ''
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}